import Route from '@ember/routing/route';
import { service } from '@ember/service';
import KpiService from 'walden-fast/services/kpi';
import type UserService from 'walden-fast/services/user';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppServicesWaldenConnectModel = Resolved<
  ReturnType<AppServicesWaldenConnectRoute['model']>
>;

export default class AppServicesWaldenConnectRoute extends Route {
  @service('kpi') declare kpiService: KpiService;
  @service('user') declare userService: UserService;

  async model() {
    const user = await this.userService.getUser();
    const availableClientNameLocals = user.clientCompanies;

    const userCanAccessService = this.userService.canAccessService(
      SERVICE_NAMES.WALDEN_CONNECT,
    );
    return {
      stats: userCanAccessService
        ? await this.kpiService.getStatsForPage('Walden Connect')
        : [],
      availableClientNameLocals,
    };
  }
}
